// extracted by mini-css-extract-plugin
export default {"surface":"ChatLayout_surface__x60KF","notice":"ChatLayout_notice__HdtO9","quietNotice":"ChatLayout_quietNotice__aDtuU"};